<template>
  <div class="agent-fd">
    <!-- 返点统计 -->
    <div class="fd-stats">
      <div class="stats-item">
        <div class="stats-value">{{ fdStats.total_fd || 0 }}</div>
        <div class="stats-label">{{ $t('total_rebate') }}</div>
      </div>
      <div class="stats-item">
        <div class="stats-value">{{ fdStats.unsettled_fd || 0 }}</div>
        <div class="stats-label">{{ $t('unsettled_rebate') }}</div>
      </div>
      <div class="stats-item">
        <div class="stats-value">{{ fdStats.settled_fd || 0 }}</div>
        <div class="stats-label">{{ $t('settled_rebate') }}</div>
      </div>
    </div>

    <!-- 返点记录 -->
    <div class="fd-list">
      <div class="list-header">
        <h3>{{ $t('rebate_record') }}</h3>
      </div>
      <div class="list-content">
        <div v-if="fdLogs.length === 0" class="empty">
          <p>{{ $t('no_rebate_records') }}</p>
        </div>
        <div v-else class="fd-item" v-for="fd in fdLogs" :key="fd.id">
          <div class="fd-header">
            <div class="fd-date">{{ fd.created_at || '-' }}</div>
            <div class="fd-game-type">{{ fd.game_type_text || fd.game_type || '-' }}</div>
          </div>
          <div class="fd-body">
            <div class="fd-info">
              <span class="fd-label">{{ $t('rebate_amount') }}</span>
              <span class="fd-amount">+{{ fd.fd_money || fd.money || 0 }}</span>
            </div>
            <div class="fd-info">
              <span class="fd-label">{{ $t('bet_amount') }}</span>
              <span class="fd-bet">{{ fd.bet_amount || 0 }}</span>
            </div>
            <div class="fd-info">
              <span class="fd-label">{{ $t('rebate_rate') }}</span>
              <span class="fd-rate">{{ fd.agent_member_rate || fd.rate || 0 }}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agentFd',
  data() {
    return {
      fdStats: {
        total_fd: 0,
        unsettled_fd: 0,
        settled_fd: 0
      },
      fdLogs: []
    };
  },
  created() {
    this.getFdStats();
    this.getFdLogs();
  },
  methods: {
    getFdStats() {
      var that = this;
      console.log('=== 调用返水统计接口 /api/team/performance ===');
      that.$apiFun.get('/api/team/performance').then(function(res) {
        console.log('返水统计返回:', res);
        if (res.code === 200 && res.data) {
          that.fdStats = {
            total_fd: res.data.total_rebate || res.data.rebate_total || 0,
            unsettled_fd: res.data.unsettled_rebate || 0,
            settled_fd: res.data.settled_rebate || 0
          };
        }
      }).catch(function(err) {
        console.error('获取返水统计错误:', err);
      });
    },
    
    getFdLogs() {
      var that = this;
      console.log('=== 调用返水记录接口 /api/getfanshui ===');
      that.$apiFun.post('/api/getfanshui', {}).then(function(res) {
        console.log('返水记录返回:', res);
        if (res.code === 200 && res.data) {
          var data = res.data;
          if (data.data && Array.isArray(data.data)) {
            that.fdLogs = data.data;
          } else if (Array.isArray(data)) {
            that.fdLogs = data;
          } else {
            that.fdLogs = [];
          }
        } else {
          that.fdLogs = [];
        }
      }).catch(function(err) {
        console.error('获取返水记录错误:', err);
        that.fdLogs = [];
      });
    }
  }
};
</script>

<style scoped>
.agent-fd {
  margin-top: 60px;
  padding: 15px;
}

.fd-stats {
  display: flex;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.stats-item {
  flex: 1;
  padding: 20px 15px;
  text-align: center;
  border-right: 1px solid #f5f5f5;
}

.stats-item:last-child {
  border-right: none;
}

.stats-value {
  font-size: 20px;
  font-weight: bold;
  color: #084ccb;
  margin-bottom: 5px;
}

.stats-label {
  font-size: 12px;
  color: #666;
}

.fd-list {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.list-header {
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.list-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.list-content {
  padding: 0 15px;
}

.empty {
  padding: 40px 0;
  text-align: center;
}

.empty p {
  color: #999;
  font-size: 14px;
}

.fd-item {
  padding: 15px 0;
  border-bottom: 1px solid #f5f5f5;
}

.fd-item:last-child {
  border-bottom: none;
}

.fd-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.fd-date {
  font-size: 14px;
  color: #333;
}

.fd-game-type {
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  padding: 2px 8px;
  border-radius: 10px;
}

.fd-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.fd-label {
  font-size: 12px;
  color: #999;
}

.fd-amount {
  font-size: 14px;
  font-weight: bold;
  color: #52c41a;
}

.fd-bet,
.fd-rate {
  font-size: 12px;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/agent/agentFd.vue